export default function FAQSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-3xl font-bold text-gray-900 mb-4">FAQ</h3>
          <p className="text-xl text-gray-900">よくあるご質問</p>
        </div>

        <div className="space-y-6">
          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 営業文章の作成は自社で行う必要がありますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 営業文章作成は弊社で行います。完成した営業文章は御社にご確認いただき、内容修正も可能です。すでに御社でご用意された営業文章がある場合は、そのまま活用することも、改善案を弊社がご提案することもできます。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 企業リストは誰が準備しますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 企業リストの作成はすべて弊社で対応いたします。追加・変更が発生しても、追加費用は一切いただきません。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 自社で保有しているリストでも送信できますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 可能です。御社からリストをお預かりすれば、そのリストにも同様に送信いたします。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 作成された企業リストを事前に確認できますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. はい、確認することができます。御社のお取引先など、送信を避けたい企業が含まれている場合は、除外チェックをお願いしています。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 送信ペースはどのくらいですか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 平均的には1日あたり500件ほど送信しますが、御社のご希望に合わせて調整も可能です。</p>
            </div>
          </div>

          {/* <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 最低契約期間や件数の制限はありますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. ご依頼いただく件数によって異なりますので、詳細はお問い合わせください。</p>
            </div>
          </div> */}

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 送信結果のレポートはもらえますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 送信先が分かるよう、Excel形式でレポートを提出いたします。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 問い合わせにつながる割合はどのくらいですか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 平均では0.2〜0.3％（1,000件中2〜3件）程度です。案件によっては0.7〜1.0％に達するケースもあります。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. NGリストをスキップできますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. もちろんスキップすることが可能です。会社名ベースでも、HPベースでも可能です。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 営業代行を使うと、自社にノウハウが残らないかと心配してます。</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. ご商談以降のプロセスはお客様に対応した頂くため、営業活動の主要部分はノウハウとして残ります。また、弊社が使用している文章、リスト等もすべて提出を致しますので、御社のノウハウとして所持していただくことができます。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. どのような業種でも対応できますか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. BtoBであれば全業界で対応可能です。弊社で保有するリスト200万社の他、新規ですべての業界の情報を取得可能です(一般消費者へのアプローチは行っておりませんのでご了承ください)</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. まずは相談だけでも大丈夫ですか？</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. 問題ございません。「プロのコンサル経験者から弊社の営業方針についての意見が欲しい」といった内容でご相談した事例もございます。お気軽にお問い合わせ下さい。</p>
            </div>
          </div>

          <div className="bg-white rounded-lg shadow-md overflow-hidden border-2 border-gray-200">
            <div className="bg-brand-blue text-white px-6 py-4">
              <h4 className="font-bold text-lg">Q. 料金の支払い方法を教えてください</h4>
            </div>
            <div className="px-6 py-4">
              <p className="text-gray-900">A. クレジットカード決済、または請求書払いとなります。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
